import BaseRepository from '@/repositories/base/BaseRepository'

class RedpacketRepository extends BaseRepository {
	// 我的红包
	getUserAlreadyGetList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/userAlreadyGetList',
			data: params,
		})
	}
	//扫码住兑换金账户明细列表
	getExchangeAmtDetailList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/getExchangeAmtDetailList',
			data: params,
		})
	}
	//扫码住酒店数据列表
	getExchangeHotelDataList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/getExchangeHotelDataList',
			data: params,
		})
	}
	//扫码住兑换金账户余额
	getExchangeAmtBalance() {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/getExchangeAmtBalance',
			data: {},
		})
	}
	//扫码住兑换金面额关联红包活动
	getExchangeRPkActivitInfo(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/getExchangeRPkActivitInfo',
			data: params,
		})
	}
	//扫码住兑换金兑换红包
	exchangeRedPacket(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/exchangeRedPacket',
			data: params,
		})
	}
	// 促销活动规则接口
	promotionRedPacketRule(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/promotionRedPacketRule',
			data: params,
		})
	}
	// 红包可领取
	getUseRedPacket(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/getUseRedPacket',
			data: params,
		})
	}
	// 用户下单可用红包列表
	redPacketQueryAvailable(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/redPacketQueryAvailable',
			data: params,
		})
	}
	// 促销规则计算优惠金额接口
	redPacketCalculatePrice(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/redPacketCalculatePrice',
			data: params,
		})
	}

	// 红包批量领取
	redPacketBatchReceive(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/redPacketBatchReceive',
			data: params,
		})
	}

	// 红包数量
	getUserRedPacketCaution(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/getUserRedPacketCaution',
			data: params,
		})
	}

    // 领取红包
	redPacketReceive(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/redPacketReceive',
			data: params,
		})
	}

	// 激活权益
	redPacketActivate(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/wallet/redPacketActivate',
			data: params,
		})
	}

	// 检查按钮是否可以点击
	getCompaginButtonDisplay(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/flowExpress/getCompaginButtonDisplay',
			data: params,
		})
	}

	// 是否展示兑换红包
	checkExchangeRedPacket(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/checkExchangeRedPacket',
			data: params,
		})
	}
}

export default RedpacketRepository
